import React from 'react';
import { EmptyState as EmptyStateContainer } from './styles';
export var EmptyState = function (_a) {
    var message = _a.message;
    return (React.createElement(EmptyStateContainer, null,
        React.createElement("p", null, message)));
};
